import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import { Grid, Paper, Typography, withStyles } from "@material-ui/core";
import styles from "../../../wrappers/admin/Admin.Styles";
import * as AccountHierarchyActions from "../../../store/AccountHierarchy";
import * as SnackbarActions from "../../../store/SnackbarStore";
import * as CompanyActions from "../../../store/CompanyStore";
import { userInRoles, UserRoleTypeEnum } from "../../..//services/authService";
import HierarchyManager from "../../../components/HierarchyManager";
import Hierarchy, { HierarchyMode } from "../../../components/Hierarchy";
import DragSourceList, {
  DragSourceListMode
} from "../../../components/DragSourceList";
import { dndType } from "../../../components/DragSourceList";
import differenceWith from "lodash/differenceWith";

class CompanyApp extends Component {
  hierarchyType = "Company";
  hierarchyTypeId = 2;

  componentWillReceiveProps(nextProps) {
    const { companies, hierarchyElements } = nextProps;
    this.setState({ companies });
    this.setState({
      companies: differenceWith(
        companies,
        hierarchyElements,
        (a, h) => a.id === h.entityId
      )
    });
  }

  componentDidMount() {
    const { requestHierarchies, requestCompanies } = this.props;
    requestHierarchies(this.hierarchyType);
    requestCompanies();
  }

  state = {
    hierarchyId: 0,
    companies: []
  };

  hierarchyChange = hierarchyId => {
    this.setState({ hierarchyId: Number(hierarchyId) });
  };

  hierarchyModified = ({ hierarchyId }) => {
    const { requestHierarchies } = this.props;
    requestHierarchies(this.hierarchyType);
  };

  hierarchyDeleted = ({ hierarchyId }) => {
    const { requestHierarchies } = this.props;
    this.hierarchyChange(0);
    requestHierarchies(this.hierarchyType);
  };

  render() {
    const { classes, hierarchies, user } = this.props;

    let hierarchyMode = userInRoles(user, [UserRoleTypeEnum.Administrator])
      ? HierarchyMode.EDIT
      : HierarchyMode.READ;
    let dragSourceListMode = userInRoles(user, [UserRoleTypeEnum.Administrator])
      ? DragSourceListMode.EDIT
      : DragSourceListMode.READ;

    return (
      <div>
        <Typography variant="h4" gutterBottom component="h2">
          Company Hierarchy
        </Typography>

        <HierarchyManager
          hierarchies={hierarchies}
          hierarchyChange={this.hierarchyChange}
          hierarchyDeleted={this.hierarchyDeleted}
          hierarchyAdded={this.hierarchyModified}
          hierarchyUpdated={this.hierarchyModified}
          hierarchyTypeId={this.hierarchyTypeId}
        />

        {this.state.hierarchyId > 0 ? (
          <div className={classes.root}>
            <Grid container spacing={8}>
              <Grid item xs={6}>
                <Paper className={classes.paper} style={{ maxHeight: 600 }}>
                  <Hierarchy
                    dndType={dndType}
                    hierarchyId={this.state.hierarchyId}
                    hierarchyTypeId={this.hierarchyTypeId}
                    hierarchyMode={hierarchyMode}
                  />
                </Paper>
              </Grid>
              <Grid item xs={6}>
                <Paper className={classes.paper} style={{ maxHeight: 600 }}>
                  <DragSourceList
                    accounts={this.state.companies}
                    dragSourceListMode={dragSourceListMode}
                  />
                </Paper>
              </Grid>
            </Grid>
          </div>
        ) : (
          undefined
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    hierarchies: state.accountHierarchy.hierarchies
      ? state.accountHierarchy.hierarchies
      : [],
    companies: state.companies.companies ? state.companies.companies : [],
    hierarchyElements: state.accountHierarchy.hierarchyElements || [],
    user: state.user.user
  };
}

export default connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign(
        {},
        AccountHierarchyActions.actionCreators,
        CompanyActions.actionCreators,
        SnackbarActions.actionCreators
      ),
      dispatch
    )
)(withStyles(styles)(DragDropContext(HTML5Backend)(CompanyApp)));
